export function languagePathBuilder(keys: Array<string>) {
  return `auth.${keys.join('.')}`;
}
